import React from "react";
import "../../../../scss/dashboard/deletemodal.css";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { toast } from "react-toastify";
import { useRequestPayment } from "../../../../api/hooks/profile";
function PaymentModal({ modal, handleClose, balance, isValid }) {
  const [buttonIsValid, setButtonIsValid] = React.useState(true);
  const { mutate: requestPaymentMutate } = useRequestPayment({
    onSuccess: () => handleClose(),
  });
  const handlePayment = () => {
    if (isValid) {
      requestPaymentMutate({});
    } else if (!isValid) {
      toast.error("Se requiere cuenta CLABE", {
        position: toast.POSITION.TOP_RIGHT,
        toastId: "error",
      });
      setButtonIsValid(false);
    }
  };
  return (
    <Modal isOpen={modal} style={{ paddingTop: "7vw" }}>
      <ModalBody
        style={{ margin: "0px auto", width: "500px", height: "250px" }}
      >
        <div
          style={{
            display: "grid",
            height: "100%",
            gridTemplateRows: "18% 55% 27%",
          }}
          className="ModalGrid"
        >
          <div className="ModalGridHeader">
            <span>Solicitar Pago</span>
            <div onClick={handleClose} style={{ cursor: "pointer" }}>
              <span>X</span>
            </div>
          </div>
          <div>
            <p>
              Da clic en Solicitar para recibir tu pago de ${balance}, para
              cualquier aclaración envia correo a{" "}
              <a
                style={{ color: "#f37b33", textDecoration: "none" }}
                href="mailto:soporte@trato.io"
              >
                soporte@trato.io
              </a>
            </p>
          </div>
          <div className="ModalGridButtons">
            <div onClick={handleClose} className="ModalGridButtons__one">
              <span>Cancelar</span>
            </div>
            <button
              onClick={handlePayment}
              className="ModalGridButtons__two"
              disabled={!buttonIsValid}
              style={{ width: "140px" }}
            >
              <span>Solicitar</span>
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default PaymentModal;
